import React, { useState } from "react";

export const Carrousel = ({ children }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const totalSlides = React.Children.count(children);
  
    const next = () => {
      setCurrentIndex((prev) =>
        prev === totalSlides - 1 ? 0 : prev + 1
      );
    };
  
    const prev = () => {
      setCurrentIndex((prev) =>
        prev === 0 ? totalSlides - 1 : prev - 1
      );
    };
  
    return (
      <div className="relative w-full h-96">
        {/* VIEWPORT */}
        <div className="overflow-hidden w-full h-full">
          {/* TRACK */}
          <div
            className="flex h-full transition-transform duration-300 ease-in-out"
            style={{
              transform: `translateX(-${currentIndex * 100}%)`,
            }}
          >
            {React.Children.map(children, (child, index) => (
              <div
                key={index}
                className="min-w-full h-full flex-shrink-0 max-w-[400px] max-h-[350px]"
              >
                {child}
              </div>
            ))}
          </div>
        </div>
  
        {/* BOTÓN IZQUIERDA */}
        <button
          onClick={prev}
          className="absolute left-3 top-1/2 -translate-y-1/2
                     z-10 bg-black/40 text-white
                     w-10 h-10 rounded-full
                     flex items-center justify-center
                     hover:bg-black/80 transition"
        >
          ◀
        </button>
  
        {/* BOTÓN DERECHA */}
        <button
          onClick={next}
          className="absolute right-3 top-1/2 -translate-y-1/2
                     z-10 bg-black/40 text-white
                     w-10 h-10 rounded-full
                     flex items-center justify-center
                     hover:bg-black/80 transition"
        >
          ▶
        </button>
      </div>
    );
  };